export function makeDebouncer(time) {
  let waitingPromise = null;
  let searchAsync = null;
  let lastValueToSearch = null;

  const debounce = async function (key, func) {
    let currentlyWaiting = null;
    let currentSearch = null;
    lastValueToSearch = key;

    if (!waitingPromise) {
      waitingPromise = new Promise(resolve => setTimeout(resolve, time));
    }

    currentlyWaiting = waitingPromise;
    await currentlyWaiting;

    if (currentlyWaiting === waitingPromise) {
      waitingPromise = null;
    }

    if (!searchAsync || searchAsync.value !== lastValueToSearch) {
      searchAsync = func(lastValueToSearch);
      searchAsync.value = lastValueToSearch;
    }
    currentSearch = searchAsync;

    return currentSearch;
  };

  return debounce;
}